// 版本1：
// const ScrollIntoView = {
//   install(Vue) {
//     // 定义全局方法 $scrollIntoView
//     Vue.prototype.$scrollIntoView = function (
//       elementType = "element",
//       selector,
//       options = {}
//     ) {
//       let element;
//       if (elementType == "element") {
//         element = document.querySelector(selector);
//       } else if (elementType == "ref") {
//         element = selector;
//       }
//       if (element) {
//         element.scrollIntoView({
//           behavior: options.behavior || "smooth", // 滚动行为，默认为平滑滚动
//           block: options.block || "start", // 垂直方向对齐方式，默认为 start
//           inline: options.inline || "nearest", // 水平方向对齐方式，默认为 nearest
//         });
//       } else {
//         console.warn(`Element with selector "${selector}" not found.`);
//       }
//     };
//   },
// };

// export default ScrollIntoView;

// 版本2：
import flexible_getfontSize from "./flexible.js";
const ScrollIntoView = {
  install(Vue) {
    Vue.prototype.$scrollIntoView = function (
      elementType = "element",
      selector,
      options = {}
    ) {
      const {
        behavior = "smooth",
        block = "start",
        inline = "nearest",
        offset = 0, // 新增的偏移量参数
      } = options;

      let element;
      if (elementType === "element") {
        element = document.querySelector(selector);
      } else if (elementType === "ref") {
        element = selector;
      }

      if (!element) {
        return console.warn(`Element with selector "${selector}" not found.`);
      }

      // 计算目标滚动位置
      const rect = element.getBoundingClientRect();
      const basePosition = window.pageYOffset + rect.top;

      // 根据对齐方式调整偏移量
      const viewportHeight = window.innerHeight;
      const elementHeight = rect.height;
      let targetPosition = basePosition;

      if (block === "end") {
        targetPosition = basePosition + elementHeight - viewportHeight;
      } else if (block === "center") {
        targetPosition = basePosition - (viewportHeight - elementHeight) / 2;
      }

      let offsetValue = offset;
      if (offsetValue.toString().includes("rem")) {
        offsetValue = flexible_getfontSize() * parseFloat(offsetValue.split("rem")[0]); // 将偏移量转换为rem单位
      }

      // 应用偏移量
      targetPosition -= offsetValue;

      // 边界检查
      const maxScroll = document.documentElement.scrollHeight - viewportHeight;
      targetPosition = Math.min(Math.max(0, targetPosition), maxScroll);

      window.scrollTo({
        top: targetPosition,
        behavior,
      });
    };
  },
};

export default ScrollIntoView;



// WEBPACK FOOTER //
// ./src/plugins/ScrollView.js